import { config } from '../config/config';
import { ConfigEnvironment } from '../config/ConfigType';

export const logger = (...args: any[]) => {
  if (config.env === ConfigEnvironment.PRODUCTION) {
    return;
  }
  console.log(...args);
};
